<agpr-master-layout [id]="'reports'" [layout]="layout">
    <ng-template let-item agprTemplate="navigation">
        <agpr-left-sidebar [id]="id"></agpr-left-sidebar>
    </ng-template>
</agpr-master-layout>

<agpr-amplify-dialog
    *ngIf="amplifyVisible && amplify"
    [dataSource]="amplify.dataSource"
    [dropdownDataSource]="amplify.dropdownDataSource"
    [(display)]="amplifyVisible"
    [localization]="amplify.localization"
    [totalRecords]="amplify.dataSource.length"
    [iconClass]="amplify.icon"
    [filterPlaceholderText]="amplify.filterPlaceholder"
    [userOptions]="amplify.userOptions"
    (onCreateNewStory)="amplify.createNew();"
    (onUseSelected)="amplify.useSelected($event);"
    (onCancel)="amplify.cancel();"
    (onClose)="amplify?.close();"
    (onSearch)="amplify.search($event)"
>
</agpr-amplify-dialog>
